import { countries } from "~/shared/constants/country.constants";
import { Select, type SelectItem, type SelectProps } from "~/ui";

const countrySelectItems: SelectItem[] = countries.map(c => ({
  value: c.code,
  label: `${c.name} (${c.code})`,
}));

type CountrySelectProps = Omit<SelectProps, "data">;

/**
 * Searchable country select backed by ISO 3166-1 alpha-2 codes.
 * US, CA, and MX are prioritized at the top of the list for chemical distribution workflows.
 */
export const CountrySelect = ({ placeholder = "Select country", ...props }: CountrySelectProps) => (
  <Select {...props} data={countrySelectItems} placeholder={placeholder} searchable clearable={props.clearable ?? true} />
);
